import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgRoot = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18 * (props.wx ?? 1)}
    height={27 * (props.hx ?? 1)}
    viewBox="0 0 18 27"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinejoin="round"
      d="M9.175 1.805c-1.332 0-4.799-1.923-6.8.176-1.605 1.683-1.013 5.73.137 8.454.428 1.013.41 2.269.324 3.443-.344 4.702 1.19 11.94 2.592 11.856 1.438-.088 1.31-8.708 3.48-9.46 1.268-.439 1.564 1.821 1.845 3.938.337 2.532.138 5.176.854 5.448.833.315 2.414-1.805 3.253-5.656.451-2.07.646-4.408.589-6.097-.037-1.094-.039-2.459.39-3.472 1.15-2.723 1.742-6.77.137-8.453-2.002-2.1-5.468-.177-6.801-.177Z"
    />
    <path
      fill={props.findingsFill || '#FF5140'}
      d="M4.893 13.5c-.28 2.59 0 5 0 6.5 1.008.425 1.494-5.201 1.5-6 0-2 .12-3.084.525-4.18.772-2.081 1.075-3.176 1.823-3.488-.674.136-1.48.826-2.348 1.668-1.369 1.327-1.36 4.205-1.5 5.5M13.233 13.5c.28 2.59 0 5 0 6.5-1.008.425-1.494-5.201-1.5-6 0-2-.12-3.084-.525-4.18-.771-2.081-1.075-3.176-1.823-3.488.674.136 1.479.826 2.348 1.668 1.369 1.327 1.36 4.205 1.5 5.5"
    />
  </svg>
);
export default SvgRoot;
